var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading && _vm.loadingVisibility)?_c('div',{staticClass:"fixed w-full h-full z-50 inset-0 bg-black opacity-75 flex justify-center items-center",attrs:{"data-qa":"overlay_loader"}},[_c('img',{staticClass:"animate-spin w-24 h-24 select-none",attrs:{"alt":"Loading…","src":"/temp/breezeline_pinwheel_white.png"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }